import commonApi from "@/api/common/commonApi";
import { GetRoleAuthorityTreeResponse } from "@/api/common/commonLimit";
import { PowerConfig, parentName } from "@/config/power";
import { Power } from "@/store/interface/common";
import { ElMessage } from "element-plus";
import { computed } from "vue";
import { useStore } from "vuex";

interface PowerObj {
  [key: string]: boolean;
}
interface UsePower {
  judgePowerGroup: (obj: PowerConfig, isDetails?: boolean) => any;
  openLink: (url: string, arr: string[], callback?: () => void) => void;
  judgePower: (arr: string[], tree?: any, isDetails?: boolean) => any;
}

export default (): UsePower => {
  const store = useStore();
  const power = computed(() => store.getters.getPower);

  const getPower = async () => {
    const power = await getTree();
    await store.dispatch("setPower", power);
  };
  /** 打开链接 */
  const openLink = (url: string, arr: string[], callback?: () => void) => {
    console.log(url);

    if (!arr?.length) return;
    if (judgePower(arr, power.value)) {
      window.open(url);
      if (callback) callback();
    } else {
      ElMessage({ message: "您暂无此功能权限", type: "warning" });
    }
  };

  /** 层层筛选如果有值代表有权限 */
  const judgePower = (arr: string[], tree: any = store.getters.getPower, isDetails?: boolean) => {
    arr = handlePro([...arr], store.getters.getTagSmallType); // 拷贝数组不更改原数组
    try {
      if (!tree) tree = store.getters.getPower;
      const name = arr.shift();
      let array = tree.find((item: { name: string | undefined }) => item.name == name);
      arr.forEach((name) => {
        array = array?.children?.find((t: { name: string }) => t.name == name);
      });

      if (isDetails) return array;
      return Boolean(array);
    } catch {
      return false;
    }
  };
  /** 筛选模块组 */
  const judgePowerGroup = (obj: PowerConfig, isDetails?: boolean) => {
    console.groupCollapsed("获取权限", obj, store.getters.getPower);
    const arr = Object.keys(obj);
    if (!arr?.length) return true;
    if (isDetails) {
      const o: PowerObj = {};
      arr.forEach((key) => {
        o[key] = judgePower(obj[key], store.getters.getPower);
      });
      console.log(o);
      console.groupEnd();
      return o;
    }
    const newArr = arr.map((key) => judgePower(obj[key], store.getters.getPower));
    console.log(newArr);
    console.groupEnd();
    return newArr.some((bol) => bol);
  };
  return {
    judgePowerGroup,
    openLink,
    judgePower,
  };
};
/** 获取权限 */
export const getTree = async () => {
  const { data } = await commonApi.GetRoleAuthorityTree();
  return anArrayOfTree(data);
};

/** 扁平化数组转树状 */
const anArrayOfTree = (arr: GetRoleAuthorityTreeResponse[] | null) => {
  const tree = [];
  const map: any = {};
  const newArr = arr?.sort((a, b) => a.parentid - b.parentid) || [];
  for (const item of newArr) {
    const newItem = (map[item.id] = { ...item, children: [] });
    if (map[item.parentid]) {
      const parent = map[item.parentid];
      parent.children.push(newItem);
    } else {
      if (newItem.level == 1) tree.push(newItem);
    }
  }
  return tree;
};

/** 筛选权限 */
const getJurisdiction = (RoleAuthority: any, arr: string[]) => {
  const data: Partial<Power> = {};
  // 获取权限数据
  const moduleId = RoleAuthority?.find((item: { name: string }) => item.name == "企业管理")?.id;
  const spId = RoleAuthority?.find((item: { name: string }) => item.name == "审批报销")?.id;
  RoleAuthority.forEach((item: any) => {
    // 企业管理
    if (item.parentid == moduleId) {
      if (item.name == "进入财务") data.cw = item.id;
      if (item.name == "进入进销存") data.jxc = item.id;
      if (item.name == "进入预算") data.ys = item.id;
    }
    if (item.parentid == spId) {
      if (item.name == "工作台") data.sp = item.id;
    }
  });
  return data;
};

/** 处理专业版权限 */
export const handlePro = (arr: string[], smallType: number): string[] => {
  console.groupCollapsed("处理高级权限", arr, smallType);
  if (smallType > 9) {
    if (arr[0] == parentName && arr[1] == "进入进销存") {
      arr = ["进销存", ...arr.slice(2)];
    }
    if (arr[0] == parentName && arr[1] == "进入财务") {
      arr = ["财务管理", ...arr.slice(2)];
    }
    if (arr[0] == parentName && arr[1] == "进入预算") {
      arr = ["预算管理", ...arr.slice(2)];
    }
  }
  console.log(arr);
  console.groupEnd();
  return arr;
};
